import React, { useState } from 'react'
import { Button, CardBody, Col, FormGroup, Label, Row } from 'reactstrap';
import { AfterNo, BeforeNo, Comma, Dash, DateFive, DateFormate, DateFour, DateOne, DateSix, DateThree, DateTwo, Decimal, Dot, FinancialYearStart, Next, PerPosition, Separator, Space, TimeZone } from '../../../Constant';
import { Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import asiaTimezones from "../../Common/Timezone/Timezone";
import { Slash } from 'react-feather';
import Typeahead from "../../../CommonElements/TypeAhead/index";



const dateformatOptions = [
    { value: "d M Y", label: DateOne },
    { value: "M d Y", label: DateTwo },
    { value: "Y M d", label: DateThree },
    { value: "d m Y", label: DateFour },
    { value: "m d Y", label: DateFive },
    { value: "Y m d", label: DateSix },
];

const specialCharacterOptions = [
    { value: "-", label: Dash },
    { value: "/", label: Slash },
    { value: ".", label: Dot },
    { value: ",", label: Comma },
    { value: " ", label: Space },
];

const positionOptions = [
    { value: "after", label: AfterNo },
    { value: "before", label: BeforeNo },
];

const decimalOptions = [
    { value: "2", label: "0.00" },
    { value: "3", label: "0.000" },
    { value: "4", label: "0.0000" },
];



const LocalisationForm = ({register,control}) => {
    const [financialDate, setFinancialDate] = useState(null);


    const handleChangeDate = date => {
        setFinancialDate(date);
    };

  return (
    <CardBody>
    <Row className="g-3">
        <Col md="6">
            <FormGroup className="mb-3">
                <Label htmlFor="financial">{FinancialYearStart}</Label>
                <DatePicker
                    style={{ padding: '12px 100px' }}
                    className="form-control "
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/yyyy"
                    selected={financialDate}
                    onChange={handleChangeDate}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                />
            </FormGroup>
        </Col>
        <Col md="6">
            <FormGroup className="mb-3">
                <Label htmlFor="time">{TimeZone}</Label>
                <Controller
                    name="timezone"
                    control={control}
                    render={({ field }) => (
                        <Typeahead
                            options={asiaTimezones}
                            onChange={(value) => {
                                field.onChange(value);
                            }}
                            value={field.value}
                        />
                    )}
                />
            </FormGroup>
        </Col>
    </Row>
    <Row className="g-3">
        <Col md="6">
            <FormGroup className="mb-3">
                <Label htmlFor="dateFormate">{DateFormate}</Label>
                <Controller
                    name="dateFormate"
                    control={control}
                    render={({ field }) => (
                        <Typeahead
                            id="dateFormate"
                            options={dateformatOptions}
                            onChange={(value) => {
                                field.onChange(value);
                            }}
                            value={field.value}
                        />
                    )}
                />
            </FormGroup>
        </Col>
        <Col md="6">
            <Label htmlFor="separator">{Separator}</Label>
            <Controller
                name="separator"
                control={control}
                render={({ field }) => (
                    <Typeahead
                        options={specialCharacterOptions}
                        onChange={(value) => {
                            field.onChange(value);
                        }}
                        value={field.value}
                    />
                )}
            />
        </Col>
    </Row>
    <Row className="g-3">
        <Col md="6">
            <Label htmlFor="confirmPW">{PerPosition}</Label>
            <Controller
                name="position"
                control={control}
                render={({ field }) => (
                    <Typeahead
                        options={positionOptions}
                        onChange={(value) => {
                            field.onChange(value);
                        }}
                        value={field.value}
                    />
                )}
            />
        </Col>
        <Col md="6">
            <Label htmlFor="confirmPW">{Decimal}</Label>
            <Controller
                name="decimal"
                control={control}
                defaultValue={decimalOptions[0]}
                render={({ field }) => (
                    <Typeahead
                        options={decimalOptions}
                        onChange={(value) => {
                            field.onChange(value);
                        }}
                        value={field.value}
                    />
                )}
            />
        </Col>
    </Row>
    <div className="text-end mt-2 ">
        <Button className="tab-button" >{Next}</Button>
        {/* <Button className="tab-button" onClick={nextTab}>{Next}</Button> */}
    </div>
</CardBody>

  )
}

export default LocalisationForm